(() => {
  // Legacy carts can contain a public shipping notice. Keep it as order metadata,
  // while the theme supplies the single caramel dispatch line for each preorder.
  const isNotice = (name, value) =>
    String(name).normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase() === 'pre-venda' &&
    String(value).includes('Envios a partir de');

  const normalizeProperties = (properties = {}) => {
    const result = { ...properties };
    for (const [name, value] of Object.entries(properties)) {
      if (!isNotice(name, value)) continue;
      if (!Object.prototype.hasOwnProperty.call(result, '_sb_preorder_notice')) result._sb_preorder_notice = value;
      delete result[name];
    }
    return result;
  };

  const normalizeFormData = (formData) => {
    for (const [name, value] of Array.from(formData.entries())) {
      const match = /^properties\[(.+)\]$/.exec(name);
      if (!match || !isNotice(match[1], value)) continue;
      const privateName = 'properties[_sb_preorder_notice]';
      if (!formData.has(privateName)) formData.set(privateName, value);
      formData.delete(name);
    }
  };

  const requestCart = async (url, body) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}),
        signal: controller.signal,
      });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error('Could not update preorder metadata');
      return cart;
    } finally {
      clearTimeout(timeout);
    }
  };

  const cleanCart = async () => {
    let cart = await requestCart(`${window.routes.cart_url}.js`);
    const limit = cart.items.length;
    for (let attempt = 0; attempt < limit; attempt += 1) {
      const item = cart.items.find((line) => Object.entries(line.properties || {}).some(([name, value]) => isNotice(name, value)));
      if (!item) return;
      cart = await requestCart(window.routes.cart_change_url, {
        id: item.key,
        quantity: item.quantity,
        properties: normalizeProperties(item.properties),
      });
    }
  };

  window.SweetbarPreorderProperties = { normalizeFormData, cleanCart };

  let pending = false;
  const bypass = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout' || !['cart', 'CartDrawer-Form'].includes(form.id)) return;
    if (bypass.delete(form) || !document.querySelector('[data-sb-legacy-preorder]')) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    const cartControls = Array.from(document.querySelectorAll('cart-items, cart-drawer-items'));
    const inertBefore = cartControls.map((element) => element.inert);
    cartControls.forEach((element) => { element.inert = true; });
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await cleanCart();
    } catch (error) {
      // A failed metadata cleanup must not stop the customer from purchasing.
      console.error(error);
    } finally {
      cartControls.forEach((element, index) => { element.inert = inertBefore[index]; });
      button.disabled = false;
      button.removeAttribute('aria-busy');
      pending = false;
      bypass.add(form);
      form.requestSubmit(button);
    }
  }, true);
})();
